<template>
  <div class="soar-container pt-12 flex flex-wrap gap-4 md:gap-0">
    <div
      :key="key"
      v-for="(card, key) in cards"
      class="w-full md:w-1/3 p-2 lg:first:ps-0 lg:end:pe-0 py-0 h-36 md:aspect-video hover:scale-105"
    >
      <div
        class="w-full h-full px-4 flex flex-col justify-center gap-y-3 border border-primary-700 rounded-lg hover:shadow-lg"
      >
        <div class="w-full flex gap-x-4">
          <div
            class="flex justify-center items-center aspect-square bg-brand-gray-300 rounded size-[60px]"
          >
            <faFileLines class="w-7 fill-primary"></faFileLines>
          </div>
          <p class="max-w-prose">{{ $t(card.label) }}</p>
        </div>
        <div class="w-full">
          <RouterLink
            :to="{
              name: 'ServiceForm',
              params: { serviceId: 1059 },
              query: { reasonId: card.reasonId, withException: false }
            }"
            class="w-full flex justify-center items-center gap-x-3 text-xs rounded-full px-3 py-1.5 border border-primary bg-primary text-white font-semibold hover:scale-105"
          >
            {{ $t('startService') }}
            <faCircleArrowRight class="w-4 fill-white" />
          </RouterLink>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import faFileLines from '@/assets/icons/faFileLines.svg?component'
import faCircleArrowRight from '@/assets/icons/faCircleArrowRight.svg?component'

const cards = [
  {
    label: 'statisticalRequestsForCompanies',
    reasonId: 1001
  },
  {
    label: 'usersKPIs',
    reasonId: 1002
  },
  {
    label: 'essentialSummaryCharts',
    reasonId: 1003
  }
]
</script>

<style lang="scss" scoped></style>
